<div class="main-container">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <span>Sub Contractor Employee</span>
                <button class="btn btn-light btn-sm" [routerLink]="['/onboarding/subcontractor/add/0']"
                    *ngIf="this.common.PageRight.IsAdd">
                    <i class="bi bi-plus-circle me-1"></i> Add Employee
                </button>
            </div>
        </div>

        <div class="card-body p-0">
            <div class="filter-section">
                <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label for="EmpCode" class="form-label">Employee Code</label>
                            <input type="text" class="form-control" placeholder="Search by code" id="EmpCode"
                                name="EmpCode" [(ngModel)]="this.Filter.EmpCode" #EmpCode="ngModel" maxlength="100"
                                (change)="clear()">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Employee Name</label>
                            <input type="text" class="form-control" placeholder="Search by name" id="EmpName"
                                name="EmpName" [(ngModel)]="this.Filter.EmpName" #EmpName="ngModel" maxlength="100"
                                (change)="clear()">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Vendor</label>
                            <ng-select name="VendorID" placeholder="Select Vendor" [items]="Vendors"
                                bindLabel="VendorName" bindValue="VendorId" [(ngModel)]="this.Filter.VendorId"
                                [selectOnTab]="true" (change)="clear()">

                                <ng-template ng-option-tmp let-item="item">
                                    <span [ngbTooltip]="item.VendorName" container="body" placement="right">{{
                                        item.VendorName }}</span>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Working Status</label>
                            <select class="form-label form-select" aria-label="filterType" placeholder="Status"
                                title="SubType" name="SubType" [(ngModel)]="this.Filter.SubType" #SubType="ngModel"
                                required (change)="clear()">
                                <option value="all">All</option>
                                <option value="A">Working</option>
                                <option value="D">Left</option>
                            </select>
                        </div>
                        <div class="col"></div>
                        <div class="col-md-auto align-self-end pb-2 gap-2">
                            <button type="button" (click)="reset()" class="btn btn-outline-primary">
                                <i class="bi bi-arrow-clockwise me-1"></i> Reset
                            </button>
                            <button class="btn btn-primary mx-2">
                                <i class="bi bi-funnel me-1"></i> Apply
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                                [disabled]="this.EmployeeData.length == 0" (click)="ExportExcel()">
                                <i class="bi bi-download me-1"></i> Export
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="table-container">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}">
                                Action</th>
                            <th style="width: 300px;">Details</th>
                            <th style="width: 150px">Vendor</th>
                            <th style="width: 150px">Branch</th>
                            <th style="width: 150px">Client</th>
                            <th style="width: 150px">Site</th>
                            <th style="width: 100px">Working Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of EmployeeData; let i = index">
                            <td [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}"
                                class="p-1">
                                <div class="text-center"><i
                                        [routerLink]="['/onboarding/subcontractor/add/' + element['EmpMasterID']]"
                                        class="bi bi-pencil-square text-warning"></i></div>
                            </td>
                            <td style="width: 300px;">
                                <div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="element['Photo'] != null && element['Photo'] != ''"
                                            (click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(element['Photo'])" />
                                        <div *ngIf="element['Photo'] == null || element['Photo'] == ''"
                                            (click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(element['FirstName'] + ' ' +
                                                element['LastName'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-10">
                                        <span class="text-label">{{element['FirstName'] + ' ' +
                                            element['LastName']}}</span><br />
                                        <span class="text-label-light">#{{element['EmpCode']}} <span
                                                *ngIf="element['DesignationName'] != null && element['DesignationName'] != ''">[{{element['DesignationName']}}]</span></span><br />
                                    </div>
                                </div>
                            </td>
                            <td style="width: 150px">
                                <div style="width: 150px">{{element['VendorCode'] + '-' + element['VendorName']}}
                                </div>
                            </td>
                            <td style="width: 150px">
                                <div style="width: 150px">{{element['BranchName']}}</div>
                            </td>
                            <td style="width: 150px">
                                <div style="width: 150px">{{element['ClientGroupName']}}</div>
                            </td>
                            <td style="width: 150px">
                                <div style="width: 150px">{{element['SiteName']}}</div>
                            </td>
                            <td style="width: 100px">
                                <div style="width: 100px">{{element['WorkStatusName']}}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>